/**
 * Estimated delivery date (product page block "delivery_estimate").
 *
 * The Liquid side renders a server-computed fallback; this script recomputes the
 * date in the shopper's browser so a cached page never shows a stale date, and
 * formats the month name through Intl using the active storefront locale.
 */
(function () {
  var SELECTOR = '[data-delivery-estimate]';

  function localeCode() {
    var lang = document.documentElement.getAttribute('lang');
    if (lang) return lang;
    if (window.Shopify && window.Shopify.locale) return window.Shopify.locale;
    return 'en';
  }

  function toInt(value, fallback) {
    var n = parseInt(value, 10);
    return isNaN(n) ? fallback : n;
  }

  function addDays(days) {
    var now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate() + days);
  }

  function format(date, opts) {
    try {
      return new Intl.DateTimeFormat(localeCode(), opts).format(date);
    } catch (e) {
      return new Intl.DateTimeFormat('en', opts).format(date);
    }
  }

  function render(el) {
    var target = el.querySelector('[data-delivery-estimate-date]');
    if (!target) return;

    var min = toInt(el.getAttribute('data-min-days'), 0);
    var max = toInt(el.getAttribute('data-max-days'), min);
    if (max < min) max = min;

    var start = addDays(min);
    var end = addDays(max);
    var text;

    if (min === max) {
      text = format(start, { day: 'numeric', month: 'long' });
    } else if (start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear()) {
      // Same month → print the month once: "22 - 25 August"
      text = format(start, { day: 'numeric' }) + ' - ' + format(end, { day: 'numeric', month: 'long' });
    } else {
      text = format(start, { day: 'numeric', month: 'long' }) + ' - ' + format(end, { day: 'numeric', month: 'long' });
    }

    target.textContent = text;
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) render(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // Theme editor: re-render when the section or block is re-rendered.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
  document.addEventListener('shopify:block:select', function (event) {
    init(event.target);
  });
})();
